// Libs
import React from 'react';
import { Typography, Box } from '@mui/material';

// Components
import OrderProductQtyLabels from '../../../../Labels/OrderProductQtyLabels';
import ApprovalLabel from '../../../../Labels/ApprovalLabel';

const OrderProductQtyBlock = ({
  orderItem,
  addressesCount,
  isRecurring,
  perUnitQty,
  totalOrdered,
  classes,
  showApproval = false,
}) => (
  <Box mt={2} className={classes.qtyBlock}>
    <div className={classes.qtyInfoText}>
      <OrderProductQtyLabels
        orderItem={orderItem}
        addressesCount={addressesCount}
        isRecurring={isRecurring}
      />
    </div>
    <Typography className={classes.qtyInfoText}>
      {`Total Items Ordered: ${perUnitQty ? totalOrdered : 'N/A'}`}
    </Typography>
    {showApproval && !isRecurring && (
      <ApprovalLabel
        orderItemStatus={orderItem.status}
        approver={orderItem.approval?.approver}
        isModified={orderItem.qty_ordered !== orderItem.qty_approved}
        variant="textMd"
        className={classes.approvalLabel}
      />
    )}
  </Box>
);

export default OrderProductQtyBlock;
